<div class="search" >
    <span class="search-icon"></span>
    <input
        class="search-input"
        #searchInput
        placeholder="{{ placeholder | translate }}"
        [ngModel]="inputValue"
        (ngModelChange)="delaySubmit($event)"
        (keyup.enter)="instantSubmit($event)"
        maxlength="100"
        popover="{{placeholder | translate}}"
        [delay]="500"
        triggers="mouseenter:mouseleave"
        data-qa="qa-search-input"
    />
    <span [hidden]="!inputValue" (click)="clear()" class="clear-icon">&times;</span>
</div>
